document.addEventListener('DOMContentLoaded', function () {
  const pageDots = document.querySelector('.page-dots');
  if (!pageDots) return;

  const dots = Array.from(pageDots.querySelectorAll('.tap-area'));
  const Max_Visible = 5;

  function updateDotView() {
    const selectedIndex = dots.findIndex(dot => dot.getAttribute('aria-current') === 'true');

    let start = Math.max(0, selectedIndex - Math.floor(Max_Visible / 2));
    let end = start + Max_Visible;

    if (end > dots.length) {
      end = dots.length;
      start = Math.max(0, end - Max_Visible);
    }

    dots.forEach((dot, index) => {
      dot.classList.remove('small', 'hidden-dot', 'a-selected');

      if (index === selectedIndex) {
        dot.classList.add('a-selected');
      }

      if (index < start || index >= end) {
        dot.classList.add('hidden-dot');
      } else if ((index === start || index === end - 1) && index !== selectedIndex) {
        dot.classList.add('small');
      }
    });

    const dotWidth = 16;
    const translateX = dotWidth * start;
    pageDots.style.transform = `translateX(-${translateX}px)`;
    pageDots.classList.remove('invisible');
  }

  const observer = new MutationObserver(() => {
    updateDotView();
  });

  dots.forEach(dot => {
    observer.observe(dot, {
      attributes: true,
      attributeFilter: ['aria-current']
    });
  });
  
  updateDotView(); 
});
